import React from "react";
import styled from "styled-components";

const Container = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 0.75rem;
`;

const ActionBar = (props: any) => {
	return <Container>{props.children}</Container>;
};
export default ActionBar;
